type DelawareAgentAddress = {
  city: string;
  country: string;
  state: string;
  street_address: string;
  street_address_line_2: string | null;
  zipcode: string;
};

const DELAWARE_REGISTERED_AGENT_ADDRESSES: DelawareAgentAddress[] = [
  {
    city: "Wilmington",
    country: "United States",
    state: "Delaware",
    street_address: "1209 Orange Street",
    street_address_line_2: null,
    zipcode: "19801",
  },
  {
    city: "Wilmington",
    country: "United States",
    state: "Delaware",
    street_address: "251 Little Falls Drive",
    street_address_line_2: null,
    zipcode: "19808",
  },
  {
    city: "Lewes",
    country: "United States",
    state: "Delaware",
    street_address: "16192 Coastal Highway",
    street_address_line_2: null,
    zipcode: "19958",
  },
  {
    city: "Dover",
    country: "United States",
    state: "Delaware",
    street_address: "8 The Green",
    street_address_line_2: "Suite B",
    zipcode: "19901",
  },
  {
    city: "Dover",
    country: "United States",
    state: "Delaware",
    street_address: "8 The Green",
    street_address_line_2: "Ste A",
    zipcode: "19901",
  },
  {
    city: "Dover",
    country: "United States",
    state: "Delaware",
    street_address: "850 New Burton Road",
    street_address_line_2: "Suite 201",
    zipcode: "19904",
  },
  {
    city: "Dover",
    country: "United States",
    state: "Delaware",
    street_address: "3500 S Dupont Highway",
    street_address_line_2: null,
    zipcode: "19901",
  },
  {
    city: "Wilmington",
    country: "United States",
    state: "Delaware",
    street_address: "704 N. King St.",
    street_address_line_2: "Suite 500",
    zipcode: "19899",
  },
  {
    city: "Wilmington",
    country: "United States",
    state: "Delaware",
    street_address: "1201 Orange St.",
    street_address_line_2: "Suite 600, One Commerce Center",
    zipcode: "19801",
  },
  {
    city: "Dover",
    country: "United States",
    state: "Delaware",
    street_address: "3500 South Dupont Highway",
    street_address_line_2: null,
    zipcode: "19901",
  },
  {
    city: "Wilmington",
    country: "United States",
    state: "Delaware",
    street_address: "1013 Centre Road",
    street_address_line_2: null,
    zipcode: "19805",
  },
  {
    city: "Wilmington",
    country: "United States",
    state: "Delaware",
    street_address: "1220 N. Market Street",
    street_address_line_2: "Suite 804",
    zipcode: "19801",
  },
  {
    city: "Claymont",
    country: "United States",
    state: "Delaware",
    street_address: "619 New York Avenue",
    street_address_line_2: null,
    zipcode: "19703",
  },
  {
    city: "Wilmington",
    country: "United States",
    state: "Delaware",
    street_address: "704 N. King Street",
    street_address_line_2: "Suite 500",
    zipcode: "19899",
  },
  {
    city: "Wilmington",
    country: "United States",
    state: "Delaware",
    street_address: "1521 Concord Pike",
    street_address_line_2: "#303",
    zipcode: "19803",
  },
  {
    city: "Newark",
    country: "United States",
    state: "Delaware",
    street_address: "19 Kris Court",
    street_address_line_2: null,
    zipcode: "19702",
  },
];

const normalize = (value?: string | null) => (value || "").trim().toLowerCase();

export const isDelawareRegisteredAgentAddress = (address: {
  country?: string | null;
  state?: string | null;
  city?: string | null;
  street_address?: string | null;
  street_address_line_2?: string | null;
  zipcode?: string | null;
}): boolean => {
  return DELAWARE_REGISTERED_AGENT_ADDRESSES.some((agentAddress) => {
    if (
      normalize(address.country) !== normalize(agentAddress.country) ||
      normalize(address.state) !== normalize(agentAddress.state) ||
      normalize(address.city) !== normalize(agentAddress.city) ||
      normalize(address.zipcode) !== normalize(agentAddress.zipcode)
    ) {
      return false;
    }

    const userStreet = normalize(address.street_address);
    const userStreet2 = normalize(address.street_address_line_2);
    const agentStreet = normalize(agentAddress.street_address);
    const agentStreet2 = normalize(agentAddress.street_address_line_2);

    // Direct match: both fields match individually
    if (userStreet === agentStreet && userStreet2 === agentStreet2) {
      return true;
    }

    // Combined match: user put "street, street2" in street_address with line2 empty
    if (agentStreet2 && !userStreet2) {
      const combined = `${agentStreet}, ${agentStreet2}`;
      if (userStreet === combined) {
        return true;
      }
    }

    return false;
  });
};
